import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class PromoBannerService {

  private keyName = 'auditor-promo-banner';
  private bannerTime = 300;
  // private bannerTime = 10000;
  constructor() { }

  getSecondsToEndOfPeriod() {
    const viewTime = this.getViewTime();
    const actualTime = parseInt((new Date().getTime() / 1000).toString());
    return this.bannerTime - (actualTime - viewTime);
  }

  getViewTime(): number {
    const actualTime = parseInt((new Date().getTime() / 1000).toString());
    let viewTime: number|string|null = localStorage.getItem(this.keyName);
    if (viewTime === null) {
      viewTime = actualTime;
      localStorage.setItem(this.keyName, actualTime.toString());
    } else {
      viewTime = parseInt(viewTime);
    }

    if (viewTime < (actualTime - 3600 * 24 * 7)) {
      viewTime = actualTime;
      localStorage.setItem(this.keyName, actualTime.toString());
    }

    return viewTime;
  }

  checkViewBanner(): boolean {
    const actualTime = parseInt((new Date().getTime() / 1000).toString());
    const viewTime = this.getViewTime();

    return viewTime > (actualTime - this.bannerTime);
  }
}
